import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import info from "@/views/info"
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// Vue.use(ElementUI);
Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: '/login' },
    // {
    //   path: "/",
    //   name: "home",
    //   component: Home
    // },
    {
      path: '/login',
      name: 'Login',
      meta: {
        keep: 1
      },
      component: () => import('../views/login/index.vue'),
    },
    {
      path: '/register',
      name: 'Register',
      meta: {
        keep: 1
      },
      component: () => import('../views/register/index.vue'),
    },
    {
      path: '/forgetPwd',
      name: 'ForgetPwd',
      meta: {
        keep: 1
      },
      component: () => import('../views/forgetPassword/index.vue'),
    },
    {
      path: '/info',
      name: 'Info',
      component: info,
      meta: {
        keep: 2
      },
      // component: () => import('../views/info/index.vue'),
    },
    {
      path: '/insight',
      name: 'Insight',
      meta: {
        keep: 2
      },
      component: () => import('../views/insight/index.vue'),
    },
    {
      path: '/mailcenter',
      name: 'Mailcenter',
      meta: {
        keep: 2
      },
      component: () => import('../views/mailcenter/index.vue'),
    },
    {
      path: '/inbox',
      name: 'Inbox',
      meta: {
        keep: 2
      },
      component: () => import('../views/inbox/index.vue'),
    },
    {
      path: '/outbox',
      name: 'Outbox',
      meta: {
        keep: 2
      },
      component: () => import('../views/outbox/index.vue'),
    },
    {
      path: '/emailConnection',
      name: 'EmailConnection',
      meta: {
        keep: 2
      },
      component: () => import('../views/emailConnection/index.vue'),
    },
    {
      path: '/starMark',
      name: 'StarMark',
      meta: {
        keep: 2
      },
      component: () => import('../views/starMark/index.vue'),
    },
    {
      path: '/follow',
      name: 'Follow',
      meta: {
        keep: 2
      },
      component: () => import('../views/follow/index.vue'),
    },
    {
      path: '/details',
      name: 'Details',
      meta: {
        keep: 2
      },
      component: () => import('../views/details/details.vue')
    },
    {
      path: '/influencers',
      name: '/Influencers',
      meta: {
        keep: 1
      },
      component: () => import('../views/influencers/index.vue')
    },
    {
      path: '/demo',
      name: 'Demo',
      meta: {
        keep: 1
      },
      component: () => import('../views/demo/index.vue')
    },
    {
      path: '/bulletinBoardDemo',
      name: 'BulletinBoardDemo',
      meta: {
        keep: 2
      },
      component: () => import('../views/bulletinBoardDemo/bulletinBoardDemo.vue')
    },
    {
      path: '/bulletinBoard',
      name: 'BulletinBoard',
      meta: {
        keep: 2
      },
      component: () => import('../views/bulletinBoard/bulletinBoard.vue')
    },
    {
      path: '/NoPermissiondemo',
      name: 'NoPermissiondemo',
      meta: {
        keep: 2
      },
      component: () => import('../views/NoPermissiondemo/NoPermissiondemo.vue')
    },
    {
      path: '/authorization',
      name: 'Authorization',
      meta: {
        keep: 2
      },
      component: () => import('../views/authorization/authorization.vue')
    },
    {
      path: '/reportDemo',
      name: 'ReportDemo',
      meta: {
        keep: 2
      },
      component: () => import('../views/reportDemo/reportDemo.vue')
    },
    {
      path: '/report',
      name: 'Report',
      meta: {
        keep: 2
      },
      component: () => import('../views/report/report.vue')
    },
    {
      path: '/sourceMaterial',
      name: 'SourceMaterial',
      meta: {
        keep: 2
      },
      component: () => import('../views/sourceMaterial/index.vue')
    },
    {
      path: '/package',
      name: 'package',
      meta: {
        keep: 2
      },
      component: () => import('../views/package/package.vue')
    },
    {
      path: '/payment',
      name: 'payment',
      meta: {
        keep: 2
      },
      component: () => import('../views/payment/payment.vue')
    },
    {
      path: '/guide',
      name: 'guide',
      meta: {
        keep: 1
      },
      component: () => import('../views/guide/guide.vue')
    },
    {
      path: '/influencerse',
      name: '/Influencerse',
      meta: {
        keep: 1
      },
      component: () => import('../views/influencerse/index.vue')
    },
    {
      path: '/configure',
      name: '/Configure',
      meta: {
        keep: 1
      },
      component: () => import('../views/configure/configure.vue')
    },
    {
      path: '/index',
      name: '/index',
      meta: {
        keep: 1
      },
      component: () => import('../views/index/index.vue')
    },
    {
      path: '/emailConnection',
      name: '/EmailConnection',
      meta: {
        title: 'EmailConnection',
        needLogin: false,
      },
      component: () => import('../views/emailConnection/index.vue')
    },

    // 子账号管理
    {
      path: '/subAccountList',
      name: '/SubAccountList',
      meta: {
        keep: 2
      },
      component: () => import('../views/subAccountList/index.vue')
    },

    // 手机端开始
    {
      path: '/info-m',
      name: 'Info-m',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/info/index.vue')
    },
    {
      path: '/insight-m',
      name: '行业洞察',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/insight/index.vue')
    },
    {
      path: '/starbrand-m',
      name: '标杆品牌',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/insight/starbrand.vue')
    },
    {
      path: '/brands-m',
      name: '品牌情报',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/insight/brandsIndex.vue')
    },
    {
      path: '/detail-m',
      name: '联盟客详情',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/insight/detail.vue')
    },
    {
      path: '/follow-m',
      name: '我的关注',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/follow/index.vue')
    },
    {
      path: '/authorization-m',
      name: '授权中心',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/multiplatform/authorization.vue')
    },
    {
      path: '/report-m',
      name: '报告详情',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/multiplatform/report.vue')
    },
    {
      path: '/bulletinBoard-m',
      name: '综合看板',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/multiplatform/bulletinBoard.vue')
    },
    {
      path: '/mailcenter-m',
      name: '邮件中心',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/mailcenter.vue')
    },
    {
      path: '/inbox-m',
      name: '收件箱',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/inbox.vue')
    },
    {
      path: '/indetail-m',
      name: '收件详情',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/inDetail.vue')
    },
    {
      path: '/outbox-m',
      name: '发件箱',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/outbox.vue')
    },
    {
      path: '/outdetail-m',
      name: '发件详情',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/outDetail.vue')
    },
    {
      path: '/starMark-m',
      name: '星标邮件',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/starMark.vue')
    },
    {
      path: '/stardetail-m',
      name: '星标详情',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/starDetail.vue')
    },
    {
      path: '/sendEmail-m',
      name: '发邮件',
      meta: {
        keep: 3
      },
      component: () => import('../views/mobile/email/sendEmail.vue')
    },

    
  ]
});
